import { render, staticRenderFns } from "./DataSetting.vue?vue&type=template&id=cf87a2a2&scoped=true"
import script from "./DataSetting.vue?vue&type=script&lang=js"
export * from "./DataSetting.vue?vue&type=script&lang=js"
import style0 from "./DataSetting.vue?vue&type=style&index=0&id=cf87a2a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf87a2a2",
  null
  
)

export default component.exports